import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";

const DeletionConfirmationModal = ({ 
  isOpen, 
  toggle, 
  onConfirm, 
  isDeleting, 
  deductionToDelete,
  t
}) => {
  if (!deductionToDelete) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirm Deletion</ModalHeader>

      <ModalBody>
       {t("are_you_sure_delete")}<strong>{deductionToDelete.deduction.name}</strong>?
      </ModalBody>

      <ModalFooter>
        <Button 
          color="danger" 
          onClick={() => onConfirm(deductionToDelete)}
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};
export default withRouter(withTranslation()(DeletionConfirmationModal));
